module.exports = __webpack_public_path__ + "static/img/fm13.614a1be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fm13.jpg
// module id = se2m
// module chunks = 1